export function clampDocPos(doc, pos) {
    if (!doc) return 0;
    return Math.max(0, Math.min(pos, doc.content.size));
}

export function getTopLevelBlockAtPos(doc, pos) {
    if (!doc || doc.childCount === 0) return null;

    const safePos = clampDocPos(doc, pos);
    const $pos = doc.resolve(safePos);
    const index = $pos.index(0);
    if (index < 0 || index >= doc.childCount) return null;

    let from = 0;
    for (let i = 0; i < index; i += 1) {
        from += doc.child(i).nodeSize;
    }

    const node = doc.child(index);
    if (!node?.isBlock) return null;

    return {
        index,
        node,
        from,
        to: from + node.nodeSize,
    };
}

export function getTopLevelBlockAtCoords(view, event) {
    const coords = {left: event.clientX, top: event.clientY};
    const pos = view.posAtCoords(coords);
    if (!pos) return null;
    return getTopLevelBlockAtPos(view.state.doc, pos.pos);
}


